// The states a queued background job is in, as an operator screen says them.
// Two System screens run work this way — the backup and the configurator sync
// — and a state spelled two ways reads as two different things happening.
// `JobProgress` is what renders them.

import { formatNumber } from '../../utils/format-number'

export const BACKGROUND_JOB = {
  running: 'Läuft …',
  /** `what` names the run in the singular — "ein Backup", "ein Sync". */
  alreadyRunning: (live: number, what: string) =>
    live === 1
      ? `Es läuft bereits ${what}. Bitte warten, bis er fertig ist.`
      : `Es laufen bereits ${formatNumber(live)} dieser Jobs. Bitte warten, bis sie fertig sind.`,
  queued: 'In der Queue — der Worker greift den Job als nächstes auf',
  /** What a screen promises when the operator closes the tab. */
  leaveHint:
    'Die Seite kann geschlossen werden. Der Job läuft weiter, das Ergebnis liegt danach hier bereit.',
} as const
